module.exports = __webpack_public_path__ + "img/twitter.4013a268.svg";